import React, { useState } from "react";
import FireFighterIcon from "../assets/Icons/redlight.png";
import ParamedicIcon from "../assets/Icons/yellowsirene.svg";
import PoliceIcon from "../assets/Icons/azurebluesirene.png";
import NineElevnIcon from "../assets/Icons/911operator.png";
import CrisiTeamIcon from "../assets/Icons/crisisteam.png";
import NineElevenSOSIcon from "../assets/Icons/911.png";
import IconOperator112 from "../assets/Icons/112operator.png";
import Icon112 from "../assets/Icons/112.png";
import EROIcon from "../assets/Icons/lifejacket.svg";

export const serviceTypes = [
  {
    label: "ERO",
    value: "ERO",
    icon: EROIcon,
  },
  {
    label: "Fire Fighter",
    value: "Fire Fighter",
    icon: FireFighterIcon,
  },
  {
    label: "Paramedic",
    value: "Paramedic",
    icon: ParamedicIcon,
  },
  {
    label: "Police",
    value: "Police",
    icon: PoliceIcon,
  },
  {
    label: "Professional Emergency Services",
    value: "Professional Emergency Services",
    icon: NineElevnIcon,
  },
  {
    label: "Crisis Response Team",
    value: "Crisis Response Team",
    icon: CrisiTeamIcon,
  },
  {
    label: "911-Service",
    value: "911-Service",
    icon: NineElevenSOSIcon,
  },
  {
    label: "911-Operator",
    value: "911-Operator",
    icon: NineElevnIcon,
  },
  {
    label: "112-Service",
    value: "112-Service",
    icon: Icon112,
  },
  {
    label: "112-Operator",
    value: "112-Operator",
    icon: IconOperator112,
  },
];

const serviceTypeSelector = ({ value, onChange }) => {
  return (
    <div>
      <label htmlFor="serviceType">service Type</label>
      <select
        id="serviceType"
        name="serviceType"
        value={value}
        onChange={onChange}
      >
        <option value="">-- Select a Service Type --</option>
        {serviceTypes.map((type, index) => (
          <option key={index} value={type}>
            {type}
          </option>
        ))}
      </select>
    </div>
  );
};

export default serviceTypeSelector;
